import { FC, useCallback, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import { useMenuContext } from '#baseMenu/hooks';
import menuJoinCss from '../assets/menu-join.module.scss';

const Join: FC = () => {
  const { isVisibleContent } = useMenuContext();
  const refJoin = useRef<HTMLDivElement>(null);
  const classNamesWithStyle = useClassNamesWithStyle();

  const handlerJoinEnter = useCallback(() => {
    refJoin.current.classList.add(menuJoinCss.menuJoin_show);
  }, []);

  const handlerJoinExit = useCallback(() => {
    refJoin.current.classList.remove(menuJoinCss.menuJoin_show);
  }, []);

  return (
    <CSSTransition
      nodeRef={refJoin}
      in={isVisibleContent}
      timeout={200}
      unmountOnExit
      onEnter={handlerJoinEnter}
      onExit={handlerJoinExit}
    >
      <div
        ref={refJoin}
        className={classNamesWithStyle(
          menuJoinCss.menuJoin,
          menuJoinCss.menuJoin_styleDefault,
          menuJoinCss.menuJoin_styleRed,
        )}
      />
    </CSSTransition>
  );
};

export { Join };
